import SectionTitle from "../common/SectionTitle";
import { CheckCircle } from "lucide-react";

const MasterPlan = () => {
  const features = [
    "Efficient land utilization",
    "Abundant green and open spaces",
    "Seamless connectivity within the township",
    "Safe, secure, and well-organized residential living",
    "Long-term sustainability and future growth",
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          title="Master Plan"
          subtitle="A thoughtfully planned community"
        />

        <div className="grid lg:grid-cols-2 gap-12 items-center mt-10">
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              Floret Town is a thoughtfully planned residential township
              designed to blend elegant architecture with abundant green spaces.
              The layout features a grand entrance, wide internal roads, and
              well-organized residential zones that ensure privacy, natural
              light, and smooth connectivity.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Dedicated areas for landscaped gardens, parks, and lifestyle
              amenities are strategically placed to create a peaceful and
              well-balanced living environment. The internal road network is
              designed for smooth traffic flow, pedestrian safety, and aesthetic
              appeal.
            </p>
            <div className="space-y-3 pt-4">
              {features.map((feature, idx) => (
                <div key={idx} className="flex items-center space-x-3">
                  <CheckCircle className="text-emerald-600" size={20} />
                  <span className="text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className=" relative group aspect-[56/37] rounded-2xl shadow-xl overflow-hidden">
            <img
              src="/masterplan.png"
              alt="Master Plan Layout"
              className="w-full h-full object-cover transition-transform duration-700 ease-out
              group-hover:scale-110"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default MasterPlan;
